import type { IntegracoesHoteleirasData } from "../types";

const integracoesHoteleirasData: IntegracoesHoteleirasData = {
  hero: {
    titulo: "O mais poderoso hub de integrações hoteleiras",
    subtitulo: "Ecossistema Conectado",
    descricao:
      "Multiplique o alcance e a eficiência do seu hotel conectando-se às ferramentas mais poderosas do mercado. Nossa plataforma oferece integração total com PMS, OTAs, gateways de pagamento, chatbots e IA, e muito mais.",
    ctaPrimario: "Saiba mais sobre nossas integrações",
    ctaSecundario: "Solicitar Nova Integração",
    imagemUrl: "/assets/imgs/integracoes-hoteleiras/img-hero.webp",
  },
  integracoes: [
    {
      id: "1",
      nome: "Booking.com",
      categoria: "otas",
      descricao: "Sincronização bidirecional de reservas e disponibilidade",
      icone: "Building",
    },
    {
      id: "2",
      nome: "Expedia",
      categoria: "otas",
      descricao: "Integração completa com a rede Expedia",
      icone: "Building",
    },
    {
      id: "3",
      nome: "Airbnb",
      categoria: "otas",
      descricao: "Conexão direta com a plataforma Airbnb",
      icone: "Home",
    },
    {
      id: "4",
      nome: "Stripe",
      categoria: "pagamentos",
      descricao: "Processamento de pagamentos internacional",
      icone: "CreditCard",
    },
    {
      id: "5",
      nome: "PagSeguro",
      categoria: "pagamentos",
      descricao: "Gateway de pagamentos brasileiro",
      icone: "CreditCard",
    },
    {
      id: "6",
      nome: "Mercado Pago",
      categoria: "pagamentos",
      descricao: "Solução completa de pagamentos",
      icone: "CreditCard",
    },
    {
      id: "7",
      nome: "QuickBooks",
      categoria: "contabilidade",
      descricao: "Integração contábil automatizada",
      icone: "Calculator",
    },
    {
      id: "8",
      nome: "Conta Azul",
      categoria: "contabilidade",
      descricao: "Gestão financeira integrada",
      icone: "Calculator",
    },
    {
      id: "9",
      nome: "Google Analytics",
      categoria: "marketing",
      descricao: "Rastreamento de conversões e comportamento",
      icone: "BarChart",
    },
    {
      id: "10",
      nome: "Facebook Pixel",
      categoria: "marketing",
      descricao: "Remarketing e conversões",
      icone: "Target",
    },
    {
      id: "11",
      nome: "Mailchimp",
      categoria: "marketing",
      descricao: "Email marketing integrado",
      icone: "Mail",
    },
    {
      id: "12",
      nome: "WhatsApp Business",
      categoria: "comunicacao",
      descricao: "Comunicação direta com hóspedes",
      icone: "MessageCircle",
    },
  ],
  beneficios: [
    {
      id: "1",
      titulo: "Operação Unificada",
      descricao:
        "Todos os seus sistemas trabalhando em sincronia, eliminando retrabalho e erros manuais.",
    },
    {
      id: "2",
      titulo: "Dados em Tempo Real",
      descricao:
        "Informações atualizadas instantaneamente em todas as plataformas conectadas.",
    },
    {
      id: "3",
      titulo: "Setup Simplificado",
      descricao:
        "Integrações configuradas em minutos, sem necessidade de conhecimento técnico.",
    },
    {
      id: "4",
      titulo: "Suporte Dedicado",
      descricao:
        "Equipe especializada para ajudar na configuração e manutenção das integrações.",
    },
  ],
  categorias: [
    {
      id: "otas",
      nome: "OTAs",
      icone: "Building",
    },
    {
      id: "pagamentos",
      nome: "Pagamentos",
      icone: "CreditCard",
    },
    {
      id: "contabilidade",
      nome: "Contabilidade",
      icone: "Calculator",
    },
    {
      id: "marketing",
      nome: "Marketing",
      icone: "Target",
    },
    {
      id: "comunicacao",
      nome: "Comunicação",
      icone: "MessageCircle",
    },
  ],
};

// ── Orçamento por PMS ─────────────────────────────────────────────────────────

interface PmsOrcamentoPayload {
  pmsId:          string;
  pmsNome:        string;
  nome:           string;
  email:          string;
  telefone:       string;
  estabelecimento: string;
  clienteFoco:    boolean;
}

// Mock — como o resto do backend do site, ainda simulado (todo o
// backend do site ainda é simulado). pmsId já vai junto no payload pra deixar
// pronta a integração real com o CRM assim que o endpoint existir.
async function submitPmsOrcamento(payload: PmsOrcamentoPayload): Promise<{ success: true }> {
  await new Promise((resolve) => setTimeout(resolve, 900));
  console.info("[integracoes-hoteleiras] Solicitação de orçamento (mock):", payload);
  return { success: true };
}

export { integracoesHoteleirasData, submitPmsOrcamento };
export type { PmsOrcamentoPayload };
